import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import useAxios from "../../../../hooks/useAxios";
import { getChipColor } from "../../../../constants/value";
import { __getTmobilejFilterGroupAssignLog } from "../../../../api/sim";

const TmobilejFilterGroupAssignHistory = () => {
  const [historyData, setHistoryData] = useState([]);
  const { assign_id } = useParams();
  const [response, call, loading] = useAxios({
    ...__getTmobilejFilterGroupAssignLog(assign_id),
  });

  useEffect(() => {
    call();
  }, []);

  useEffect(() => {
    if (response?.status) setHistoryData(response.data);
  }, [response]);

  if (loading) return <Title content="Please wait..." variant="subtitle2" gutterBottom />;

  return (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Bulk Assign Filter Groups Log
        </Typography>
      </Box>

      {response && historyData.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">MSISDN</TableCell>
                    <TableCell align="left">Subscriber ID</TableCell>
                    <TableCell align="left">Filter Type</TableCell>
                    <TableCell align="left">Group Names</TableCell>
                    <TableCell align="left">Group IDs</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell align="left">{historyData.data.msisdn}</TableCell>
                    <TableCell align="left">{historyData.data.subscriber_id || "-"}</TableCell>
                    <TableCell align="left">{historyData.data.filter_type}</TableCell>
                    <TableCell align="left">
                      {(historyData.data.selected_group_names || []).join(", ")}
                    </TableCell>
                    <TableCell align="left">
                      {(historyData.data.selected_group_ids || []).join(", ")}
                    </TableCell>
                    <TableCell align="left">
                      <Link to={`/tmobilej/filter_group_assign/batch/${historyData.data.batch_id}`}>
                        {historyData.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={historyData.data.status}
                        size="small"
                        color={getChipColor(historyData.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {historyData.data.last_updated &&
                        `${format(new Date(historyData.data.last_updated), "MMMM d, y hh:mm a")}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default TmobilejFilterGroupAssignHistory;
